module.exports = __webpack_public_path__ + "4bd3f5a87b6c5b2a2ed15850365ed450.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/social-media-icons/facebook.png
// module id = 3670
// module chunks = 0